import { createContext } from "@lit/context";

export const recordsContext = createContext("records-context");
